import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
import Activity from '../../../models/Activity';
import { useRequestdata } from '../useRequestData';
import { useTranslation } from 'react-i18next';
import StudentRecordActivities from '../StudentRecordActivities/StudentRecordActivities';
import { useAcademicTranscriptIsComplete } from '../Request.Context';
import './RequestRow.css';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
interface RequestRowProps {
  row: Activity,
  isRowSelected: (value:Activity) => boolean,
  selectRow: (e: ChangeEvent<HTMLInputElement>, row: Activity) => void,
  isSourceInstitutionEqualToTargetInstitution: boolean | null
  validUser?: boolean;
}
const RequestRow:React.FC<RequestRowProps> = ({ row, isRowSelected, selectRow, isSourceInstitutionEqualToTargetInstitution, validUser }) => {
  // This lines are used to support the modal in the request row, but this functionaity will be in the third step in the future
  const requestData = useRequestdata({});
  const validate = useAcademicTranscriptIsComplete();
  const [canEditData, setCanEditData] = useState(false);
  const [completedData, setCompletedData] = useState(false);
  const [open, setOpen] = useState(false);
  const [activityToShow, setActivityToShow] = useState<Activity | null>(null);
  const { t } = useTranslation();

  const item = row;

  const handleClose = () => {
    setOpen(false);
    setCanEditData(true)
  }

  const handleCancel = () => {
    if (!canEditData) {
      const fakeEvent = {
        target: { checked: false }
      } as ChangeEvent<HTMLInputElement>;
    
      selectRow(fakeEvent, row);
      setCompletedData(false);
      setCanEditData(false)
    }
    setOpen(false);
  };
  

  useEffect(() => {
    if (item && requestData?.activities?.length > 0) {
      const activityChecked = requestData?.activities?.find((activity: Activity) => (activity.id === item.id))
      if (activityChecked) {
        setActivityToShow(activityChecked);
        if (validate(activityChecked)) {
          setCompletedData(true);
        } else {
          setCompletedData(false);
        }
      } else {
        setActivityToShow(item);
      }
    }
  }, [validate, requestData.activities]);
  // End of the modal functionality

  useEffect(() => {
    const selected = isRowSelected(row)
    const activityChecked = requestData?.activities?.find((activity: Activity) => (activity.id === row.id))
    if (selected && !validate(activityChecked) && !validUser) {
      setOpen(true);
    }

  }, [isRowSelected(row)]);


  useEffect(() => {
    const selected = isRowSelected(row)
    if (selected) {
      setCanEditData(true);
    } else {
      setCanEditData(false);
    }
  }, []);


  const onHandleChecked = (e: ChangeEvent<HTMLInputElement>) => {
    selectRow(e, row);
    if (e.target.checked) {
      setOpen(true);
    } else {
      setCanEditData(false)
      setCompletedData(false)
    }
  };

  return (
    <>
      <TableRow data-testid={'row'} sx={{ display: 'table-row' }}>
        <TableCell className="REQXXI-Request-RuleChecked" align="left" scope="row">
          <Checkbox
            color="primary"
            checked={isRowSelected(row)}
            onChange={onHandleChecked}
            id={`activeCheckbox-${row.id}`}
            data-testid={`checkbox-${row.id}`}
            disabled={validUser}
          />
        </TableCell>
        <TableCell className="REQXXI-Request-Source" align="left" scope="row">
          <Typography key={row?.id}>{row?.name}</Typography>
        </TableCell>
        <TableCell className="REQXXI-Request-Source" align="left" scope="row">
          { canEditData &&
              <Button variant="contained" onClick={() => setOpen(true)} color={'primary'}>
              <Tooltip title={validUser? t('viewLabel') : t('editData')}>
                {validUser? <VisibilityIcon/> : <EditIcon/>}
              </Tooltip>
              </Button>
          }
        </TableCell>
      </TableRow>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
        PaperProps={{ className: 'REQXXI-RequestRow-DialogContainer' }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', flexDirection: 'column', gap: 3, color: 'black' }}>
            <Typography fontSize="20px">{t('generalConditions')}</Typography>
            <StudentRecordActivities item={activityToShow ?? item} key={activityToShow?.id ?? item.id} requestData={requestData}
              isSourceInstitutionEqualToTargetInstitution={isSourceInstitutionEqualToTargetInstitution} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        {!validUser && <Button onClick={handleCancel} color="primary">
            {t('cancelLabel')}
          </Button>}
        <Button data-testid="savebutton" onClick={handleClose} color="primary" disabled={!completedData} variant="contained">
            {validUser? t('acceptLabel') : t('saveLabel')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RequestRow;
